<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M12 2.5 L13.6 9.2 L20 11 L13.6 12.8 L12 19.5 L10.4 12.8 L4 11 L10.4 9.2 Z"></path>
    <circle cx="19.5" cy="4.5" r="1.2"></circle>
    <circle cx="4.5" cy="19.5" r="1"></circle>
  </svg>
</template>

<script>
export default {
  name: 'IconSpark',
  props: {
    size: { type: [String, Number], default: 16 },
  },
};
</script>
